import { FrontUrls } from 'Constants/FrontUrls'
import React, { lazy, useEffect } from 'react'
import { LazyRoute, filtersSlice, PAGE_SLUG } from 'Modules'
import { Switch } from 'react-router-dom'
import { useUnmount } from 'Src/hooks/useUnmount'
import { useAppDispatch } from 'Src/hooks'
import { organizationSlice } from 'Pages/advertisement/store/slices/organizations.slice'
import { SocketChannel, socketSlice } from 'Modules/Socket'

const ReportCreateLazy = lazy(
	() => import('Pages/advertisement/components/Reports/ReportForm/index')
)
const CreativeCreateLazy = lazy(
	() => import('Pages/advertisement/components/Creatives/CreativeForm/index')
)
const OrganizationCreateLazy = lazy(
	() => import('Pages/advertisement/components/Organization/OrganizationForm/index')
)
const ContractCreateLazy = lazy(
	() => import('Pages/advertisement/components/Contracts/ContractForm/index')
)
const AdvertisementListLazy = lazy(() => import('Pages/advertisement/components/AdvertisementTabs'))
const LogsLazy = lazy(() => import('Pages/advertisement/components/common/Logs/index'))

const actions = {
	getDict: organizationSlice.actions.getDict,
	clearFilters: filtersSlice.actions.clearFilters,
	subscribeChannels: socketSlice.actions.subscribeChannels,
	unSubscribeChannels: socketSlice.actions.unSubscribeChannels,
}

export const AdvertisementRoutes = () => {
	const { getDict, clearFilters, subscribeChannels, unSubscribeChannels } = useAppDispatch(actions)

	useUnmount(() => {
		clearFilters(PAGE_SLUG.ADVERTISEMENT)
	})

	useEffect(() => {
		getDict()
		subscribeChannels([SocketChannel.ORD_CHANNEL])
		return () => {
			unSubscribeChannels([SocketChannel.ORD_CHANNEL])
		}
	}, [])

	return (
		<Switch>
			<LazyRoute
				path={FrontUrls.advertisment.logs}
				lazyComponent={LogsLazy}
				key={FrontUrls.advertisment.logs}
			/>
			<LazyRoute
				path={FrontUrls.advertisment.report_edit}
				lazyComponent={ReportCreateLazy}
				key={FrontUrls.advertisment.report_edit}
			/>
			<LazyRoute
				path={FrontUrls.advertisment.report_create}
				lazyComponent={ReportCreateLazy}
				key={FrontUrls.advertisment.report_create}
			/>
			<LazyRoute
				path={FrontUrls.advertisment.creative_edit}
				lazyComponent={CreativeCreateLazy}
				key={FrontUrls.advertisment.creative_edit}
			/>
			<LazyRoute
				path={FrontUrls.advertisment.creative_create}
				lazyComponent={CreativeCreateLazy}
				key={FrontUrls.advertisment.creative_create}
			/>
			<LazyRoute
				path={FrontUrls.advertisment.contract_edit}
				lazyComponent={ContractCreateLazy}
				key={FrontUrls.advertisment.contract_edit}
			/>
			<LazyRoute
				path={FrontUrls.advertisment.contract_create}
				lazyComponent={ContractCreateLazy}
				key={FrontUrls.advertisment.contract_create}
			/>
			<LazyRoute
				path={FrontUrls.advertisment.organization_edit}
				lazyComponent={OrganizationCreateLazy}
				key={FrontUrls.advertisment.organization_edit}
			/>
			<LazyRoute
				path={FrontUrls.advertisment.organization_create}
				lazyComponent={OrganizationCreateLazy}
				key={FrontUrls.advertisment.organization_create}
			/>
			<LazyRoute
				path={FrontUrls.advertisment.index}
				lazyComponent={AdvertisementListLazy}
				key={FrontUrls.advertisment.index}
			/>
		</Switch>
	)
}
